module.exports = __webpack_public_path__ + "img/word_sl.c6c5b0ba.png";